import * as React from "react";
import Context from "./Context";
import "./ButtonShow.styl";

export default class ButtonShow extends React.Component<{
    total: number;
}> {

    private root: React.RefObject<HTMLDivElement> = React.createRef();
    private anim: React.RefObject<HTMLDivElement> = React.createRef();

    public constructor(props) {
        super(props);
        this.handleScroll = this.handleScroll.bind(this);
    }

    private handleScroll(): void {
        if (this.props.total == 0) {
            const rect = this.root.current.getBoundingClientRect();
            if (rect.bottom > 70 && rect.bottom < window.innerHeight) {
                this.anim.current.setAttribute("data-active", "1");
            } else {
                this.anim.current.setAttribute("data-active", "0");
            }
        } else {
            this.anim.current.setAttribute("data-active", "0");
        }
    }

    public componentDidMount(): void {
        window.addEventListener("load", this.handleScroll);
        window.addEventListener("resize", this.handleScroll);
        window.addEventListener("scroll", this.handleScroll);
    }

    public componentWillUnmount(): void {
        window.removeEventListener("load", this.handleScroll);
        window.removeEventListener("resize", this.handleScroll);
        window.removeEventListener("scroll", this.handleScroll);
    }

    public render(): React.ReactNode {
        return (
            <Context.Consumer>
                {({dispatch, translate}) => (
                    <div className="Discussion-ButtonShow-Root" onClick={() => {
                        dispatch("display", {display: true, autofocus: true});
                    }} ref={this.root}>
                        <div className="Discussion-ButtonShow-Border"/>
                        <div className="Discussion-ButtonShow-Content">
                            <div className="Discussion-ButtonShow-Anim" ref={this.anim}>
                                <div className="Discussion-ButtonShow-Row">
                                    <div className="Discussion-ButtonShow-Icon"/>
                                    {this.renderLabel(translate, this.props.total)}
                                </div>
                                {this.renderPromo(translate, this.props.total)}
                            </div>
                        </div>
                    </div>
                )}
            </Context.Consumer>
        );
    }

    private renderPromo(translate: Function, total: number): React.ReactNode {
        if (total > 0) {
            return null;
        }
        return (
            <div className="Discussion-ButtonShow-Row">
                <div className="Discussion-ButtonShow-Icon"/>
                <div className="Discussion-ButtonShow-Label">
                    <div className="Discussion-ButtonShow-LabelShort">
                        {translate("BUTTON_SHOW_0_SHORT")}
                    </div>
                    <div className="Discussion-ButtonShow-LabelLong">
                        {translate("BUTTON_SHOW_0")}
                    </div>
                </div>
            </div>
        );
    }

    private renderLabel(translate: Function, total: number): React.ReactNode {
        switch (total) {
            case 0: {
                return (
                    <div className="Discussion-ButtonShow-Label">
                        <div className="Discussion-ButtonShow-LabelShort">
                            {translate("BUTTON_SHOW_3_SHORT", {count: total.toString()})}
                        </div>
                        <div className="Discussion-ButtonShow-LabelLong">
                            {translate("BUTTON_SHOW_3_SHORT", {count: total.toString()})}
                        </div>
                    </div>
                );
            }
            case 1: {
                return (
                    <div className="Discussion-ButtonShow-Label">
                        <div className="Discussion-ButtonShow-LabelShort">
                            {translate("BUTTON_SHOW_1_SHORT")}
                        </div>
                        <div className="Discussion-ButtonShow-LabelLong">
                            {translate("BUTTON_SHOW_1")}
                        </div>
                    </div>
                );
            }
            case 2:
            case 3:
            case 4: {
                return (
                    <div className="Discussion-ButtonShow-Label">
                        <div className="Discussion-ButtonShow-LabelShort">
                            {translate("BUTTON_SHOW_2_SHORT", {count: total.toString()})}
                        </div>
                        <div className="Discussion-ButtonShow-LabelLong">
                            {translate("BUTTON_SHOW_2", {count: total.toString()})}
                        </div>
                    </div>
                );
            }
            default: {
                return (
                    <div className="Discussion-ButtonShow-Label">
                        <div className="Discussion-ButtonShow-LabelShort">
                            {translate("BUTTON_SHOW_3_SHORT", {count: total.toString()})}
                        </div>
                        <div className="Discussion-ButtonShow-LabelLong">
                            {translate("BUTTON_SHOW_3", {count: total.toString()})}
                        </div>
                    </div>
                );
            }
        }
    }

}